import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import { fromLonLat } from 'ol/proj';
import { Fill, Stroke, Style } from 'ol/style';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';
import MultiPolygon from 'ol/geom/MultiPolygon';
import LineString from 'ol/geom/LineString';
import MultiLineString from 'ol/geom/MultiLineString';
import Text from 'ol/style/Text';
import Point from 'ol/geom/Point';
import { transform } from 'ol/proj';
import CircleStyle from 'ol/style/Circle';
import Icon from 'ol/style/Icon';
import { toStringHDMS } from 'ol/coordinate';
import Overlay from 'ol/Overlay';
import { toLonLat } from 'ol/proj';
import { Draw, Select, Modify, Snap } from 'ol/interaction';
//import GeoJSON from 'ol/format/GeoJSON';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { RequestService } from '../../../services/request.service';
import { DatePipe } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { data } from 'jquery';

import { DataTableDirective} from 'angular-datatables';
import { from, Subject } from 'rxjs';

export var globalType: any = "";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: any = {};
  // dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  
  isLoading: boolean = false;
  showTable: boolean = false;
  progressbar: any = {}
  totalDevices: number = 0;
  totalActiveDevices: number = 0;
  totalInactiveDevices: number = 0;
  totalCleanToilets: number=0;
  totalDirtyToilets: number=0;
  totalToilet: number = 0;

  errorMessage: string = '';

  showDiv: boolean = false;
  toggleDiv() {
    this.showDiv = !this.showDiv;
  }
  constructor(
    private request: RequestService,
    private http: HttpClient,
    private router: Router,
    private loader: NgxUiLoaderService,
    private cdr: ChangeDetectorRef
  ) { }
  public doughnutChartLabels = ["Clean", "Ok", "Dirty"];
  public doughnutChartData = [0, 2, 1];
  public doughnutChartType = "doughnut";
  public doughnutChartColors = [{
    backgroundColor: ["#14abef", "#02ba5a", "#d13adf", "#fba540"],
    borderWidth: [0, 0, 0, 0]
  }];
  public doughnutChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      position: 'bottom',
      display: false,
      labels: {
        boxWidth: 8
      }
    },
    tooltips: {
      displayColors: false
    }
  };

  dashboardForm: any = {};

  vector;
  source;
  ngOnInit() {
    globalType="";
    
    this.source = new VectorSource();
    this.vector = new VectorLayer({
      source: this.source,
      style: new Style({
        stroke: new Stroke({
          color: 'black',
          width: 5
        })
      })
    });

    this.LoadMap();

    this.ViewToilets();
    this.totalInstallDevice();
    this.GetGraphData();
    // // this.DeviceLogReport("All");
    this.DeviceLogReportForMap("All");
    this.getHourlyData();
    // this.getWeeklyData(); 
    // this.getDevicePeopleCountData();
    this.DirtyDevices();
    
  }

  dirtyRowData:any;
  deviceData=[];
  async DirtyDevices() {
    try {
      this.deviceData=[];
      const requestData = {};
      this.dtTrigger=new Subject<any>();
      const data: any = await this.request.post('/dashboard/view_dirty_toilet_status', requestData);
      this.dtTrigger.next();
      for (let objKey of Object.keys(data.result)) {
        let dataObj = data.result[objKey];
        this.deviceData.push(dataObj);
      }
      this.dirtyRowData = this.deviceData;
    } catch (error) {}
  }

  ShowContactDetail(data){
    // console.log(data.ho_name);
    $("#hoName").text(data.ho_name+" ("+data.ho_mobile+")");
    $("#csiName").text(data.csi_name+" ("+data.csi_mobile+")");
    $("#darogaName").text(data.daroga_name+" ("+data.daroga_mobile+")");
  }

  onClearDeviceData(){
    this.getDevicePeopleCountData();
  }

  map: Map;
  googleLayerHybrid: any;
  googleLayerHybrid2: any;
  public anchors;
  LoadMap() {
    this.googleLayerHybrid2 = new TileLayer({
      source: new XYZ({
        //url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        url: 'https://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}'
      })
    });

    this.googleLayerHybrid = new TileLayer({
      source: new XYZ({
        url: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'
      })
    });

    /* Elements that make up the popup. */
    // this.container = $("#popup").val(); //document.getElementById('popup');
    // this.content = $("#popup-content").val(); //document.getElementById('popup-content');
    // this.closer = $("#popup-closer").val(); //document.getElementById('popup-closer');

    let container1 = document.getElementById('popup');
    let content1 = document.getElementById('popup-content');
    let closer1 = document.getElementById('popup-closer');


    closer1.onclick = function () {
      overlay1.setPosition(undefined);
      closer1.blur();
      return false;
    };
    let overlay1 = new Overlay({
      element: container1,
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });
    this.map = new Map({
      target: 'map',
      overlays: [overlay1],
      layers: [this.googleLayerHybrid2, this.vector],
      view: new View({
        center: fromLonLat([75.896823, 22.74764]),
        zoom: 12,
        minZoom: 2,
        maxZoom: 20
      }),
    });

    this.map.on('singleclick', function (evt) {
      //alert(evt.coordinate);
      let feature = evt.map.forEachFeatureAtPixel(evt.pixel,
        function (feature, layer) {
          return feature;
        });
      if (feature) {
        //alert(feature.get('type'));
        if (feature.get('type') == "device_position") {
          let device_id = feature.get('device_id');
          let address = feature.get('address');
          let toilet_no = feature.get('toilet_no');
          let google_toilet_id = feature.get('google_toilet_id');
          let mappingName="";
          if(toilet_no!=null && toilet_no!=""){
            mappingName=toilet_no;
          }else{
            mappingName=device_id;
          }
          let toilet_name = feature.get('toilet_name');
          let lattitude = feature.get('lattitude');
          let longitude = feature.get('longitude');
          let air_quality_status = feature.get('air_quality_status');
          let log_date_time = feature.get('log_date_time');
          let people_count = feature.get('people_count');
          let water_lavel = feature.get('water_lavel');
          let person_count = feature.get('person_count');
          let feedback = feature.get('feedback');
          let feedback_icon = "";
          if (feedback == "Clean") {
            feedback_icon = "assets/images/excellent.png";
          } else if (feedback == "Ok") {
            feedback_icon = "assets/images/good.png";
          } else if (feedback == "Dirty") {
            feedback_icon = "assets/images/bad.png";
          } else {
            feedback_icon = "assets/images/not_available.png";
          }
          let device_information = `
          <style>
            .track_table_idle{
              padding: .25rem !important;
              vertical-align: top;
              border-top: 1px solid #dee2e6;
              white-space: normal !important;
              word-break: normal !important;
              word-wrap: break-word !important;
            }
          </style>
          <table class="table table-bordered table-striped" style="font-size:14px;">
              <tr>
                  <th style="background-color:#0a766c; color:white;" colspan="2" class="text-center track_table_idle">Toilet Details</th>
              </tr>
              <!--tr>
                  <th width="50%" class="track_table_idle"><b>Device ID</b></th>
                  <td class="track_table_idle">`+ device_id + `</td>
              </tr-->
              <tr>
                  <th width="50%" class="track_table_idle"><b>Toilet ID</b></th>
                  <td class="track_table_idle">`+ mappingName + `</td>
              </tr>
              <tr>
                  <th width="50%" class="track_table_idle"><b>MoHUA (GTL ID)</b></th>
                  <td class="track_table_idle">`+ google_toilet_id + `</td>
              </tr>
              <tr>
                  <th width="50%" class="track_table_idle"><b>Toilet Name</b></th>
                  <td class="track_table_idle">`+ toilet_name + `</td>
              </tr>
              <tr>
                  <td colspan="2" class="track_table_idle">`+ address + `</td>
              </tr>
              <tr>
                <td class="text-center track_table_idle"><b>Coordinates</b></td>
                <td class="track_table_idle">`+ lattitude + `,` + longitude + `</td>
              </tr>
              <tr>
                <td class="text-center track_table_idle"><b>Air Quality</b></td>
                <td class="track_table_idle">`+ air_quality_status + `</td>
              </tr>
              <tr>
                <td class="text-center track_table_idle"><b>Water Level</b></td>
                <td class="track_table_idle">`+ water_lavel + `</td>
              </tr>
              <tr>
                <td class="text-center track_table_idle"><b>Person Count</b></td>
                <td class="track_table_idle">`+ person_count + `</td>
              </tr>
              <tr>
                <td class="text-center track_table_idle"><b>Log Date Time</b></td>
                <td class="track_table_idle">`+ log_date_time + `</td>
              </tr>
              <tr>
                <td class="text-center track_table_idle"><b>Feedback</b></td>
                <td class="track_table_idle">`+ feedback + ` 
                  <img id="icon" width="25" height="25" src="`+ feedback_icon + `">
                </td>
              </tr>
          </table>`;

          let coordinate = transform([parseFloat(longitude), parseFloat(lattitude)], 'EPSG:4326', 'EPSG:3857');
          let hdms = toStringHDMS(coordinate);
          content1.innerHTML = device_information;
          overlay1.setPosition(coordinate);
        } else {

        }
      }
    });

  }

  airQualityArr = [];
  airQualityLabelArr = [];
  airQualityRowData;
  goodAirQuality = 0;
  moderateAirQuality = 0;
  unhealthyAirQuality = 0;
  veryUnhealthyAirQuality = 0;
  hazardousAirQuality = 0;
  feedbackArr = [];
  feedbackLabelArr = [];
  feedbackColorArr = [];
  feedbackRowData;
  feedbackExcellent = 0;
  feedbackGood = 0;
  feedbackPoor = 0;
  feedbackNA = 0;
  waterLavelArr = [];
  waterLavelLabelArr = [];
  waterLavelRowData;
  waterLavelEmpty = 0;
  waterLavelHalf = 0;
  waterLavelFull = 0;
  airQualityColorArr = [];
  async GetGraphData() {
    const data = {};
    this.isLoading = true;
    this.airQualityArr = [];
    this.airQualityLabelArr = [];
    this.feedbackArr = [];
    this.feedbackLabelArr = [];
    this.waterLavelArr = [];
    this.waterLavelLabelArr = [];
    this.feedbackColorArr = [];
    this.airQualityColorArr = [];
    try {
      const response: any = await this.request.post('/dashboard/view_graph_rating_data',data);

      const raw = response.result;
      this.airQualityRowData = {
        "Good": raw.good_aqi,
        "Moderate": raw.moderate_aqi,
        "Unhealthy": raw.unhealthy_aqi,
        // "Very Unhealthy": raw.very_unhealthy_aqi,
        // "Hazardous": raw.hazardous_aqi
      };

      // Group Feedback
      this.feedbackRowData = {
        "Excellent": raw.excellent_feedback,
        "Good": raw.good_feedback,
        "Poor": raw.poor_feedback,
        "N/A": raw.no_feedback
      };

      // Group Water Level
      this.waterLavelRowData = {
        "Empty Tank": raw.empty_tank,
        "Half Tank": raw.half_tank,
        "Full Tank": raw.full_tank
      };

      let objData1 = this.airQualityRowData;
      let objData2 = this.feedbackRowData;
      let objData3 = this.waterLavelRowData;

      for (let [key, val] of Object.entries(objData1)) {
        if (key == "Good") {
          this.goodAirQuality = Number(val);
          this.airQualityColorArr.push("#14abef");
        } else if (key == "Moderate") {
          this.moderateAirQuality = Number(val);
          this.airQualityColorArr.push("#02ba5a");
        } else if (key == "Unhealthy") {
          this.unhealthyAirQuality = Number(val);
          this.airQualityColorArr.push("#d13adf");
        } 
        // else if (key == "Very Unhealthy") {
        //   this.veryUnhealthyAirQuality = Number(val);
        //   this.airQualityColorArr.push("#fba540");
        // } else {
        //   this.hazardousAirQuality = Number(val);
        //   this.airQualityColorArr.push("#000");
        // }
        this.airQualityLabelArr.push(key);
        this.airQualityArr.push(val);
      }
      let status="";
      for (let [key, val] of Object.entries(objData2)) {
        // console.log(key+" :: "+val);+9
        if (key == "Excellent") {
          status="Clean";
          this.feedbackExcellent = Number(val);
        } else if (key == "Good") {
          status="Ok";
          this.feedbackGood = Number(val);
        } else if (key == "Poor") {
          status="Dirty";
          this.feedbackPoor = Number(val);
        } else {
          status="N/A";
          this.feedbackNA = Number(val);
        }
        // this.feedbackLabelArr.push(key);
        this.feedbackLabelArr.push(status);
        if (key == "Excellent") {
          this.feedbackColorArr.push("#191970");
        } else if (key == "Good") {
          this.feedbackColorArr.push("#00BFFF");
        } else if (key == "Poor") {
          this.feedbackColorArr.push("#008080");
        } else {
          this.feedbackColorArr.push("#7CB9E8");
        }
        this.feedbackArr.push(val);
      }
      for (let [key, val] of Object.entries(objData3)) {
        // console.log(key+" :: "+val);+9
        if (key == "Empty Tank") {
          this.waterLavelEmpty = Number(val);
        } else if (key == "Half Tank") {
          this.waterLavelHalf = Number(val);
        } else {
          this.waterLavelFull = Number(val);
        }
        this.waterLavelLabelArr.push(key);
        this.waterLavelArr.push(val);
      }
      this.AirQualityGraph(this.airQualityArr, this.airQualityLabelArr, this.airQualityColorArr);
      this.FeedbackGraph(this.feedbackArr, this.feedbackLabelArr, this.feedbackColorArr);
      this.WaterLavelGraph(this.waterLavelArr, this.waterLavelLabelArr);
    } catch (error) {
      this.errorMessage = 'Error fetching data from the server.';
      console.error('API Error:', error);
    }
    finally {
      this.isLoading = false; // Data load hone ke baad loader hide
    }
  }


  airQualityLabels;
  airQualityData;
  airQualityType;
  airQualityColors;
  airQualityOptions;
  AirQualityGraph(airQualityArr, airQualityLabelArr, airQualityColorArr) {
    // Chart properties
    this.airQualityLabels = airQualityLabelArr;
    this.airQualityData = airQualityArr;
    this.airQualityType = "bar";
    this.airQualityColors = [{
      // backgroundColor: ["#14abef", "#02ba5a", "#d13adf", "#fba540", "#000"],
      backgroundColor: airQualityColorArr,
      borderWidth: [0, 0, 0, 0]
    }];
    this.airQualityOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'bottom',
        display: false,
        labels: {
          boxWidth: 8
        }
      },
      tooltips: {
        displayColors: false
      }
    };
  }

  InstallDevices() {
    this.router.navigate(['/form/install-device-report']);
  }
  ActiveDevices() {
    this.router.navigate(['/form/active-device-report']);
  }
  InactiveDevices() {
    this.router.navigate(['/form/inactive-device-report']);
  }
  ToiletReports(type:any) {
    globalType = type;
    this.router.navigate(['/form/toilet-report']);
  }
  ArrQualityReports() {
    this.router.navigate(['/form/air-quality-report']);
  }
  FeedbackReports() {
    this.router.navigate(['/form/user-feedback-report']);
  }

  feedbackLable;
  feedbackData;
  feedbackType;
  feedbackColors;
  feedbackOptions;
  FeedbackGraph(feedbackArr, feedbackLabelArr, feedbackColorArr) {
    // Chart properties
    this.feedbackLable = feedbackLabelArr;
    this.feedbackData = feedbackArr;
    this.feedbackType = "bar";
    this.feedbackColors = [{
      // backgroundColor: ["#02ba5a", "#d13adf", "#c01010", "#000"],
      backgroundColor: feedbackColorArr,
      borderWidth: [0, 0, 0, 0]
    }];
    this.feedbackOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'bottom',
        display: false,
        labels: {
          boxWidth: 8
        }
      },
      tooltips: {
        displayColors: false
      },
      // scales: {
      //   xAxes: [{
      //     gridLines: {
      //       display: false
      //     }
      //   }],
      //   yAxes: [{
      //     gridLines: {
      //       display: false
      //     }
      //   }]
      // }
    };
  }

  //Water Level
  waterLevelLable;
  waterLevelData;
  waterLevelType;
  waterLevelColors;
  waterLevelOptions;
  WaterLavelGraph(waterLavelArr, waterLavelLabelArr) {
    // Chart properties
    this.waterLevelLable = waterLavelLabelArr;
    this.waterLevelData = waterLavelArr;
    this.waterLevelType = "bar";
    this.waterLevelColors = [{
      backgroundColor: ["#191970", "#00BFFF", "#008080"],
      borderWidth: [0, 0, 0, 0]
    }];
    this.waterLevelOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'bottom',
        display: false,
        labels: {
          boxWidth: 8
        }
      },
      tooltips: {
        displayColors: false
      }
    };
  }
  // CHART-1 Line Chart
  public lineChartData: any = [];
  public lineChartLabels: any = [];
  public lineChartOptions: any = {
    responsive: true,
    scales: {
      xAxes: [{
        ticks: {
          autoSkip: true,
          maxRotation: 45,
          minRotation: 0
        },
        scaleLabel: {
          display: true,
          labelString: 'Hours'
        }
      }],
      yAxes: [{
        ticks: {
          beginAtZero: true,
          stepSize: 10,
        },


        scaleLabel: {
          display: false,
          labelString: 'People Count'
        }
      }]
    },

    legend: {
      position: 'top',
      display: true
    },
    tooltips: {
      mode: 'index',
      intersect: false
    }
  };
  public lineChartColors: any = [
    {
      backgroundColor: 'rgba(63,81,181,0.8)',
      borderColor: 'rgba(63,81,181,1)',
      pointBackgroundColor: 'rgba(63,81,181,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(63,81,181,1)'
    }
  ];
  public lineChartLegend = false;
  public lineChartType = 'bar';

  //get line chart data
  async getHourlyData() {
    const data = {};
    this.lineChartData = [];
    this.lineChartLabels=[];
    try {
       const response: any = await this.request.post('/dashboard/view_person_count_hourly',data);
      //  console.log(response);
       for (let objKey of Object.keys(response)) {
        let dataObj = response[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            // console.log(dataObj[objKey1].time);
             this.lineChartLabels.push(dataObj[objKey1].time);
             if(dataObj[objKey1].time=="00:00"){
              this.lineChartData.push(0);
             }else{
              this.lineChartData.push(dataObj[objKey1].person_count);
             }
          } 
        }				
      }
    } catch (error) {
      console.error('Error fetching hourly data:', error);
    }
  }

  //CHART-2 bar chart code
  public barChartData: any = [];
  public barChartLabels: any = [];
  public barChartOptions: any = {
    responsive: true,
    scales: {
      xAxes: [{
        ticks: {
          autoSkip: true,
          maxRotation: 45,
          minRotation: 0
        },
        scaleLabel: {
          display: true,
          labelString: 'Date'
        }
      }],
      yAxes: [{
        ticks: {
          beginAtZero: true,
          stepSize: 10,
        },


        scaleLabel: {
          display: false,
          labelString: 'People Count'
        }
      }]
    },
    legend: {
      position: 'top',
      display: true
    },
    tooltips: {
      mode: 'index',
      intersect: false
    }
  };
  public barChartColors: any = [
    {
      backgroundColor: 'rgba(63,81,181,0.8)',
      borderColor: 'rgba(63,81,181,1)',
      pointBackgroundColor: 'rgba(63,81,181,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(63,81,181,1)'
    }
  ];
  public barChartLegend = false;
  public barChartType = 'bar';


  // getdata for bar chart
  async getWeeklyData() {
    const data = {};
    this.barChartData = [];
    this.barChartLabels=[];

    try {
      const response: any = await this.request.post('/dashboard/view_person_count_last_seven_days',data);
       console.log(response);
       for (let objKey of Object.keys(response)) {
        let dataObj = response[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            // console.log(dataObj[objKey1].time);
            this.barChartLabels.push(dataObj[objKey1].time);
            this.barChartData.push(dataObj[objKey1].person_count);
          } 
        }				
      }
      if (response.status=="SUCCESS") {
        this.cdr.detectChanges();
      } else {
        console.error('Error in response:', response.message);
      }
    } catch (error) {
      console.error('Error fetching weekly data:', error);
    }
  }



  //CHART-3
  public deviceBarChartData: any = [];
  public deviceBarChartLabels: any = [];
  public deviceBarChartOptions: any = {
    responsive: true,
    scales: {
      xAxes: [{
        ticks: {
          autoSkip: true,
          maxRotation: 45,
          minRotation: 0
        },
        scaleLabel: {
          display: true,
          labelString: 'Device'
        }
      }],
      yAxes: [{
        ticks: {
          beginAtZero: true,
          stepSize: 10,
        },


        scaleLabel: {
          display: false,
          labelString: 'People Count'
        }
      }]
    },
    legend: {
      position: 'top',
      display: true
    },
    tooltips: {
      mode: 'index',
      intersect: false
    }
  };
  public deviceBarChartColors: any = [
    {
      backgroundColor: 'rgba(63,81,181,0.8)',
      borderColor: 'rgba(63,81,181,1)',
      pointBackgroundColor: 'rgba(63,81,181,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(63,81,181,1)'
    }
  ];
  public deviceBarChartLegend = false;
  public deviceBarChartType = 'bar';

  async getDevicePeopleCountData() {
    
    this.deviceBarChartData = [];
    this.deviceBarChartLabels = [];
    const logData = {};
    try {
      const response: any = await this.request.post('/dashboard/view_toilet_feedback_log_data', logData);
      // console.log(response);
      for (let objKey of Object.keys(response.result)) {
        let dataObj = response.result[objKey];
        this.deviceBarChartLabels.push(dataObj.device_id);
        this.deviceBarChartData.push(dataObj.person_count);
      }
      this.rowData = this.deviceLogDetails;
      console.log(this.rowData);
    } catch (error) {
      this.errorMessage = 'Error fetching data from the server.';
      console.error('API Error:', error);
    }
  }



  //just try to find address

  toiletData = [];
  deviceDataArr;
  async ViewToilets() {
    try {
      this.toiletData=[];
      const device = {
        'toilet_id': 0,
      };
      const data: any = await this.request.post('/master/view_toilet',device);
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            let arr = {
              id:dataObj[objKey1].device_id,
              deviceLabel:`${dataObj[objKey1].device_id}:${dataObj[objKey1].address}(Zone -${dataObj[objKey1].zone_id}, Ward -${dataObj[objKey1].ward_id})`
            };
            // console.log(arr);
            this.toiletData.push(arr);
          } 
        }				
      }
      this.deviceDataArr = this.toiletData;
      console.log(this.deviceDataArr);
    } catch (error) {}
  }






  //FOR SELECT DEVICE 
  async getHourlyDataDevicewise(device_id) {
    const device = {
      'deviceId': device_id
    };
    // console.log(device);
    this.deviceBarChartData = [];
    this.deviceBarChartLabels = [];
    try {
      const response: any = await this.request.post('/dashboard/view_person_count_devicewise_hourly',device);
      // console.log(response);
      for (let objKey of Object.keys(response.result)) {
        let dataObj = response.result[objKey];
        this.deviceBarChartLabels.push(dataObj.time);
        this.deviceBarChartData.push(dataObj.person_count);
      }
      this.cdr.detectChanges();
      
    } catch (error) {
      console.error('Error fetching hourly data:', error);
    }
  }

  dashboardGraphHeading="";
  public chartClicked(e, graphType) {
    if (e.active.length > 0) {
      const chart = e.active[0]._chart;
      const activePoints = chart.getElementAtEvent(e.event);
      if (activePoints.length > 0) {
        // get the internal index of slice in pie chart
        const clickedElementIndex = activePoints[0]._index;
        let label = chart.data.labels[clickedElementIndex];
        // get value by index
        // console.log(chart.data.datasets);
        const value = chart.data.datasets[0].data[clickedElementIndex];
        const labelValue = chart.data.datasets[0].label;
        if(graphType=="feedback" && label=="Ok"){
          label = "Ok Feedback";
        }
        if(graphType=="aqi"){
          this.dashboardGraphHeading = "Air Quality ("+label+")";
        }else if(graphType=="feedback"){
          this.dashboardGraphHeading = "Toilet Feedback ("+label+")";
        }else if(graphType=="water_lavel"){
          this.dashboardGraphHeading = "Water Level ("+label+")";
        }
        $("#devicePopupModalLabel").text(this.dashboardGraphHeading);
        this.DeviceGraphLogReport(label,graphType);
        // console.log(clickedElementIndex, label, value,labelValue);

      }
    }
  }

  chartClickedDevicewise(e) {
    if (e.active.length > 0) {
      const chart = e.active[0]._chart;
      const activePoints = chart.getElementAtEvent(e.event);
      if (activePoints.length > 0) {
        // get the internal index of slice in pie chart
        const clickedElementIndex = activePoints[0]._index;
        const label = chart.data.labels[clickedElementIndex];
        // get value by index
        console.log(chart.data.datasets);
        const value = chart.data.datasets[0].data[clickedElementIndex];
        const labelValue = chart.data.datasets[0].label;
        // this.DeviceLogReport(label);
        // console.log(clickedElementIndex, label, value,labelValue);

      }
    }
  }

  deviceLogDetails = [];
  isFeedback=false;
  isWaterLavel=false;
  REQUEST_KEY_MAP: { [key: string]: string } = {
    // AQI
    "Good": "good_aqi",
    "Moderate": "moderate_aqi",
    "Unhealthy": "unhealthy_aqi",
    // "Very Unhealthy": "very_unhealthy_aqi",
    // "Hazardous": "hazardous_aqi",

    // Feedback
    "Excellent": "excellent_feedback",
    "Good Feedback": "good_feedback",
    "Poor": "poor_feedback",
    "No Feedback": "no_feedback",

    // Water Tank
    "Empty Tank": "empty_tank",
    "Half Tank": "half_tank",
    "Full Tank": "full_tank",

  };

  async DeviceGraphLogReport(type,graphType) {
    // console.log(type);
    let request_key = this.REQUEST_KEY_MAP[type];
    const logData = {
      request_key: request_key,
      request_val: 1
    };
    if(graphType=="feedback" && type=="Ok Feedback"){
      type = "Ok";
    }
    // console.log(logData);
    this.rowData = [];
    this.deviceLogDetails = [];
    try {
      const response: any = await this.request.post('/dashboard/view_toilet_feedback_log_data', logData);
      // console.log(response);
      for (let objKey of Object.keys(response.result)) {
        let dataObj = response.result[objKey];
        // console.log(type+" :: "+dataObj.water_lavel);
        if (type == dataObj.air_quality_status) {
          this.isFeedback=false;
          this.isWaterLavel=false;
          this.deviceLogDetails.push(dataObj);
        }else if (type == dataObj.water_lavel) {
          this.deviceLogDetails.push(dataObj);
          this.isFeedback=false;
          this.isWaterLavel=true;
        }else if (type == dataObj.feedback) {
          this.isFeedback=true;
          this.isWaterLavel=false;
          this.deviceLogDetails.push(dataObj);
        }
      }
      this.rowData = this.deviceLogDetails;
      // console.log(this.rowData);
    } catch (error) {
      this.errorMessage = 'Error fetching data from the server.';
      console.error('API Error:', error);
    }
  }



  public chartHovered(e: any): void {

  }

  targetPercentage = 100;
  currentPercentage = 0; 
  totalOkToilets=0;
  totalUnderRepairToilets=0;
  async totalInstallDevice(): Promise<void> {
    const getInstallData = {};
    try {
      this.isLoading = true;
      const response: any = await this.request.post('/dashboard/view_dashboard_data', getInstallData);
      // console.log(response);
      if (response.status === "SUCCESS") {
        const result = response.result;
        this.totalDevices = result.total_devices;
        this.totalActiveDevices = result.total_active_devices;
        this.totalInactiveDevices = result.total_inactive_devices;
        this.totalToilet = result.total_toilets;
        this.totalCleanToilets=result.total_clean_toilet;
        this.totalDirtyToilets=result.total_dirty_toilet;
        this.currentPercentage = result.clean_performance;
        this.totalOkToilets = result.total_ok_toilet;
        this.totalUnderRepairToilets = this.totalToilet-(this.totalCleanToilets+this.totalDirtyToilets+this.totalOkToilets);
        $(".totalToilet").text(this.totalToilet);
        $(".totalCleanToilets").text(this.totalCleanToilets);
        $(".totalOkToilets").text(this.totalOkToilets);
        $(".totalDirtyToilets").text(this.totalDirtyToilets);
        $(".totalUnderRepairToilets").text(this.totalUnderRepairToilets);
        $(".currentPercentage").text(this.currentPercentage+" %");
      } 
      this.isLoading = false;
    } catch (error) {
      this.errorMessage = 'Error fetching data from the server.';
      console.error('API Error:', error);
    }
  }

  //Get Table Data
  rowData;
  async DeviceLogReport(feedback_type) {
    const logData = {
      'action': "view_toilet_feedback_log_data",
      feedback_type: feedback_type
    };
    this.rowData = [];
    try {
      const response: any = await this.request.post('', logData);
      //this.dtTrigger.next();
      for (let objKey of Object.keys(response)) {
        let dataObj = response[objKey];

        this.rowData = dataObj.data;

      }

    } catch (error) {
      this.errorMessage = 'Error fetching data from the server.';
      console.error('API Error:', error);
    }
  }

  // rowData;
  async DeviceLogReportForMap(feedback_type) {
    const logData = {};
    this.rowData = [];
    try {
      const response: any = await this.request.post('/dashboard/view_toilet_feedback_log_data', logData);
      for (let objKey of Object.keys(response.result)) {
        let dataObj = response.result[objKey];
        // console.log(dataObj);
        this.ShowMarker(dataObj.water_lavel, dataObj.person_count, dataObj.lattitude, dataObj.longitude, dataObj.toilet_name, dataObj.toilet_no,dataObj.google_toilet_id,dataObj.address, dataObj.device_id, dataObj.air_quality_status, dataObj.log_date_time, dataObj.feedback);
      }

      // console.log(JSON.stringify(this.rowData));
      // await new Promise(resolve => setTimeout(() => resolve(this.DeviceLogReport(feedback_type)), 30000));

    } catch (error) {
      this.errorMessage = 'Error fetching data from the server.';
      console.error('API Error:', error);
    }
  }

  dataDate: any;
  curDate: any;
  delta: any;
  vectorLayer: any = [];
  ShowMarker(water_lavel, person_count, lat, lon, toilet_name, toilet_no,google_toilet_id, address, device_id, air_quality_status, log_date_time, feedback) {
    if (lat == 0 || lon == 0) return;
    let centerPoint = transform([lon, lat], 'EPSG:4326', 'EPSG:3857');
    let mappingName="";
    if(google_toilet_id!="" && google_toilet_id!=null){
      mappingName = google_toilet_id;
    }else{
      mappingName = device_id;
    }
    let iconFeature = new Feature({
      type: "device_position",
      geometry: new Point(centerPoint),
      device_id: device_id,
      address: address,
      toilet_name: toilet_name,
      toilet_no:toilet_no,
      google_toilet_id:google_toilet_id,
      lattitude: lat,
      longitude: lon,
      device_icon: "assets/images/device_icon.png",
      air_quality_status: air_quality_status,
      water_lavel: water_lavel,
      person_count: person_count,
      log_date_time: log_date_time,
      feedback: feedback,
      population: 4000,
      rainfall: 500
    });

    let opacity = 1;
    let icon;
    let offsetY = -15;
    icon = 'assets/images/device_icon.png';
    let iconStyle = new Style({
      image: new Icon(({
        anchor: [0.5, 15],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        opacity: opacity,
        offset: [0, 0],
        src: icon
      })),
      text: new Text({
        font: 'bold 12px verdana,Calibri,sans-serif',
        fill: new Fill({ color: '#F00' }),
        offsetY: offsetY,
        stroke: new Stroke({
          color: '#fff', width: 1
        }),
        text: mappingName
      })
    });

    iconFeature.setStyle(iconStyle);

    let vectorSource = new VectorSource({
      features: [iconFeature]
    });

    let bShow = true;
    if (bShow) {
      if (this.vectorLayer[device_id] !== null) {
        this.map.removeLayer(this.vectorLayer[device_id]);
      }

      this.vectorLayer[device_id] = new VectorLayer({
        source: vectorSource
      });
      this.map.addLayer(this.vectorLayer[device_id]);
    }
  }

}